<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Requisitions &nbsp;
          <add-button
            link="/procurement-management/requisitions/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Requisitions</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <!-- Export To Excel -->
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="Exportrequisitions.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="requisitions_excel"
                :fields="excel_fields"
                worksheet="Requisitions"
                name="Requisition.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- <br /> -->
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel Name</th>
                    <th>Requisition Number</th>
                    <th>Is Approved on Vessle</th>
                    <th>Approved on Vessel Date</th>
                    <th>Is Approved At Office</th>
                    <th>Approved at office Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="requisitions.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(requisition, at) in requisitions"
                    :key="`requisition${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ requisition.vessel.name }}</td>
                    <td>
                      {{ requisition.requisition_no }}
                    </td>
                    <td>
                      {{
                        requisition.is_approved_on_vessel == true ? "Yes" : "No"
                      }}
                    </td>
                    <td>
                      {{ requisition.approved_on_vessel_date | ddmmyyyy }}
                    </td>
                    <td>
                      {{
                        requisition.is_approved_at_office == true ? "Yes" : "No"
                      }}
                    </td>
                    <td>
                      {{ requisition.approved_at_office_date | ddmmyyyy }}
                    </td>

                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/requisitions/${requisition.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(requisition.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "requisition",
  data() {
    return {
      requisitions: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      requisitions_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Vessel Name": "vessel_name",
        "Requisition Number": "requisition_no",
        "Is Approved On Vessel": "is_approved_on_vessel",
        "Approved on Vessel Date": "approved_on_vessel_date",
        "Is Approved at Office": "is_approved_at_office",
        "Approved at Office Date": "approved_at_office_date",
      },
      Exportrequisitions: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let requisitions = await axios.get(
        `/requisitions?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.requisitions = requisitions.data.data;
      this.count = requisitions.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let requisitions = await axios.get(
        `/requisitions?search=${this.searchData}`
      );
      this.requisitions = requisitions.data.data;
      this.count = requisitions.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Requisition Data";
      this.requisitions_excel = [];
      let Exportrequisitions = [];
      Exportrequisitions = await axios.get(`/requisitions`);
      this.Exportrequisitions = Exportrequisitions.data.data;
      let sr_no = 1;
      this.Exportrequisitions.forEach((requisition) => {
        this.requisitions_excel.push({
          sr_no: sr_no,
          vessel_name: requisition.vessel.name ? requisition.vessel.name : "",
          requisition_no: requisition.requisition_no
            ? requisition.requisition_no
            : "",
          is_approved_on_vessel:
            requisition.is_approved_on_vessel == true ? "Yes" : "No",
          approved_on_vessel_date: requisition.approved_on_vessel_date
            ? requisition.approved_on_vessel_date
            : "",
          is_approved_at_office:
            requisition.is_approved_at_office == true ? "Yes" : "No",
          approved_at_office_date: requisition.approved_at_office_date
            ? requisition.approved_at_office_date
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=requisitions`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
